module.exports = __webpack_public_path__ + "img/kbeauty-2.1bc23ee5.svg";